import * as React from 'react';

import { useTheme } from '../../theme';
import { Aircraft } from '@websky/graphql';
import cn from 'classnames';
import ImageWithFallback from '../../ImageWithFallback';

export interface Props {
	aircraft: Aircraft;
	isReturnFlight?: boolean;
	fallbackAircraft?: string;
	className?: string;
	returnClassName?: string;
	onClick?: () => void;
}

const AircraftLivery: React.FunctionComponent<Props> = ({
	aircraft,
	isReturnFlight,
	className,
	returnClassName,
	onClick,
	fallbackAircraft = 'https://cdn.websky.aero/content/default-content/images/Aircrafts/738/738.png'
}) => {
	const css = useTheme('AircraftLivery').AircraftLivery;

	const aircraftIcon = isReturnFlight && aircraft?.iconRt ? aircraft.iconRt : aircraft?.icon;
	const isReturnPlane = isReturnFlight && !aircraft?.iconRt;

	return (
		<div
			className={cn(css.plane, className, {
				[css.plane_return]: isReturnPlane,
				[returnClassName]: returnClassName && isReturnPlane
			})}
			onClick={onClick}
		>
			<ImageWithFallback src={aircraftIcon} fallbackSrc={fallbackAircraft} alt={aircraft?.name} />
		</div>
	);
};

export default AircraftLivery;
